import '../WorkspaceActionsInfo.scss';
import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_InfoModal } from '../../../../design/modals/infoModal/S_InfoModal';
import { WorkspaceActionsTable } from '../table/WorkspaceActionsTable';

interface IProps {
  show: boolean;
  toggle: () => void;
}

export const WorkspaceActionsModal = ({ show, toggle }: IProps): ReactElement => {
  const { t } = useTranslator();
  const header = t('teams.workspace_actions.modal_header');
  const ok = t('teams.workspace_actions.modal_button_text');

  return (
    <S_InfoModal
      isOpen={show}
      buttonText={ok}
      headerText={header}
      onClick={toggle}
      toggle={toggle}
      className='workspace-actions-modal'
    >
      <WorkspaceActionsTable />
    </S_InfoModal>
  );
};
